<router-outlet />
<app-menu />
<app-footer />

<ngx-notifier></ngx-notifier>
